import { render, staticRenderFns } from "./MobilityContentBox.vue?vue&type=template&id=0ffc2b77"
import script from "./MobilityContentBox.vue?vue&type=script&lang=js"
export * from "./MobilityContentBox.vue?vue&type=script&lang=js"
import style0 from "./MobilityContentBox.vue?vue&type=style&index=0&id=0ffc2b77&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports